import React from "react";

const PaymentMethods = () => {
  return <div> payment</div>;
};
export default PaymentMethods;
